"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchUpdate = void 0;
function noop(cb) {
    cb();
}
exports.batchUpdate = noop;
//# sourceMappingURL=batch_update.js.map